import React, { useId } from 'react';
import { cx } from './_cx';

/**
 * Select (UI primitive)
 *
 * Includes optional label + hint/error text with proper aria wiring.
 */
export function Select({
  id,
  label,
  hint,
  error,
  className,
  selectClassName,
  children,
  ...props
}) {
  const autoId = useId();
  const resolvedId = id || `pv-select-${autoId}`;
  const hintId = hint ? `${resolvedId}-hint` : undefined;
  const errorId = error ? `${resolvedId}-error` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;

  return (
    <div className={cx('pv-field', className)}>
      {label ? (
        <label className="pv-label" htmlFor={resolvedId}>
          {label}
        </label>
      ) : null}
      <select
        id={resolvedId}
        className={cx('pv-select', selectClassName)}
        aria-describedby={describedBy}
        aria-invalid={error ? 'true' : undefined}
        {...props}
      >
        {children}
      </select>
      {hint ? (
        <div id={hintId} className="pv-hint">
          {hint}
        </div>
      ) : null}
      {error ? (
        <div id={errorId} className="pv-error">
          {error}
        </div>
      ) : null}
    </div>
  );
}

